module.exports = __webpack_public_path__ + "static/netflix-ccxp-6-08071a7d10df6b335fc15a98ddd9efa3.jpg";